// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("../provider/Context.bs.js");
var Tracking = require("../provider/Tracking.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");

function useUserAction($$event) {
  var match = Context.Config.getState(undefined);
  var track = Belt_Option.map(Caml_option.nullable_to_opt(match.trackUserAction), (function (tracker) {
          return function (param) {
            return Tracking.Amplitude.trackUserAction(tracker, param);
          };
        }));
  return function (param) {
    if (track !== undefined) {
      return Curry._1(track, $$event);
    }
    
  };
}

function useTeaserUserAction($$event, parentPage) {
  var tracker = useUserAction($$event);
  return function (param) {
    if ($$event !== "home_teaser") {
      return Curry._1(tracker, undefined);
    }
    if (parentPage === undefined) {
      return ;
    }
    if (parentPage.domain) {
      return ;
    }
    var match = parentPage.pageKind;
    if (match === 4) {
      return Curry._1(tracker, undefined);
    }
    
  };
}

function usePageView(page) {
  var match = Context.Config.getState(undefined);
  var trackPageView = match.trackPageView;
  var pageView;
  if (typeof page === "number") {
    switch (page) {
      case /* Home */4 :
          pageView = "home_page";
          break;
      case /* Program */5 :
          pageView = "program_page";
          break;
      case /* SubCategory */7 :
          pageView = "category_page";
          break;
      default:
        pageView = "other_page";
    }
  } else {
    pageView = page.TAG === /* Rc */1 ? "rc_page" : "other_page";
  }
  React.useEffect((function () {
          var track = Belt_Option.map((trackPageView == null) ? undefined : Caml_option.some(trackPageView), (function (tracker) {
                  return function (param) {
                    return Tracking.Amplitude.trackPageView(tracker, param);
                  };
                }));
          if (track !== undefined) {
            Curry._1(track, pageView);
          }
          
        }), [
        page,
        trackPageView
      ]);
}

exports.useUserAction = useUserAction;
exports.useTeaserUserAction = useTeaserUserAction;
exports.usePageView = usePageView;
/* react Not a pure module */
